import { stringIsNullOrBlank, stringIsNullOrEmpty } from '_P/strings';
import { GeoResp } from "@/services/Geo";
import { Address } from '../models/Address';
export class ValidationRules {

    //errors
    public static abstractText: string = "Значение введено неверно";
    public static errorPasswordMassage: string = "Пароль должен быть длинее 6 символов и содержать минимум 1 цифру";
    public static leftLettersMessage: string = "Посторонние символы";

    //abstract
    public static requiredRule = (v: any) => !!v || v === 0 || v === undefined || "Введите данные";
    public static requiredDateRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите дату";

    public static requiredMarkRule = (v: any) => !!v || v === 0 || v === undefined || "Выберите марку";
    public static requiredModelRule = (v: any) => !!v || v === 0 || v === undefined || "Выберите модель";
    public static requiredModificationRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите мощность/модификацию";
    public static requiredCarYearRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите год";
    public static requiredVinRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите VIN";
    public static requiredBodyRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите номер кузова";
    public static requiredChassisRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите номер шасси";
    public static requiredDocBeginDateRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите дату выдачи";

    //public static requiredSeriesAndNumberRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите серию и номер";
    public static requiredSeriesRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите серию";
    public static requiredNumberRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите номер";
    public static requiredDkDateRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите дату окончания";

    public static requiredEmailRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите e-mail";
    public static requiredPhoneRule = (v: any) => !!v || v === 0 || v === undefined || "Укажите телефон";

    public static isVinCH = (v: string) => (/^[QIOABCDEFGHJKLMNPRSTUVWXYZЙШЩФИСВУАПРОЛДЬТЗКЫЕГМЦЧНЯ0-9]*$/i.test(v)) || ValidationRules.leftLettersMessage;
    public static isAlphanumericKeys = (v: string) => /^[a-zA-Z0-9\-]*$/i.test(v) || ValidationRules.abstractText;
    public static maxUpperCaseChar = (v: string) => {
        let upperCount = 0;
        const maxUpperChars = v?.includes('-') ? 2 : 1;
        v?.split('').forEach((letter)=>{
            if (letter >= "А" && letter <= "Я") upperCount++;
        })
        return upperCount <= maxUpperChars || "Превышено разрешённое количество букв в верхнем регистре"
    }

    public static isNumRule = (v: any) => !isNaN(v) || "Значение не является числом";
    public static requiredStrRule = (v: any) => !stringIsNullOrBlank(v) || "Обязательно к заполнению";
    public static dateRule = function (v: any) {
        if (v == "" || v == null) return true;
        if (v.match(/[0-3][0-9][.][0-1][0-9][.](19|20)([0-9]{2})/) == null || v == "Invalid Date") return "Неверная дата";
        else return true;
    };

    public static maxDate = function (v: string, range: number) {
        return new Date(v.replace(/(\d+)\.(\d+)\.(\d+)/, "$3-$2-$1")).getTime() < new Date().addDays(range).getTime() || ValidationRules.abstractText;
    }
    public static birthDate=function(v:any)
    {
        if (v == "" || v == null) return true;
        if(v.match(/[0-3][0-9][.][0-1][0-9][.](19|20)([0-9]{2})/) != null || v != "Invalid Date")
        {
            const bd = new Date(v.replace(/(\d+)\.(\d+)\.(\d+)/, "$3-$2-$1")).addYears(18);
            const dn = new Date();

            if(bd.getTime()>=dn.getTime())
            {
                return "Неверная дата"
            }
        }
        return true;
    };

    public static beginDate=function(v:any)
    {
        if (v == "" || v == null) return true;
        if(v.match(/[0-3][0-9][.][0-1][0-9][.](19|20)([0-9]{2})/) != null || v != "Invalid Date")
        {
            const bd = new Date(v.replace(/(\d+)\.(\d+)\.(\d+)/, "$3-$2-$1"));
            const dn = new Date()

            if(bd.getTime()<=dn.getTime())
            {
                return "Неверная дата"
            }
        }
        return true;
    };

    public static dateRuleBegin = function (v: any) {
        if (stringIsNullOrEmpty(v)) return "Обязательно к заполнению";
        if (v != "Invalid Date") {
            const dateBegin = new Date(v.replace(/(\d+)\.(\d+)\.(\d+)/, "$3-$2-$1"));
            const dateNow = new Date();
            const timeDiff = Math.abs(dateBegin.getTime() - dateNow.getTime());
            const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            if (diffDays > 60)
                return "Неверная дата";
        }

        return true;
    }

    public static passportDocDate = function (bd: Date, passDate: Date): boolean | string{
        if(!bd || !passDate) return false;
        if (bd) {
            if (bd >= passDate) {
                return "Не может быть раньше даты рождения";
            } else if (
                new Date(bd).addYears(14) > passDate
            ) {
                return "Паспорт получают с 14 лет";
            }
        }
        return true;
    }
    public static firstLicenseDate = function(bd: Date, passDate: Date): boolean | string{
        if(bd?.toString() == "Invalid Date" || passDate?.toString() == "Invalid Date" )
            return false;

        if(!passDate)
            return true;

        if (bd) {
            if (passDate < new Date().addYears(-90))
                return "Неверная дата";

            const adultDate = new Date(bd).addYears(18);
            const docDate = new Date(passDate);
            // последний день года, иначе валидация по году начала стажа работает некорректно
            docDate.setMonth(11, 31);

            if (bd >= passDate)
                return "Не может быть раньше даты рождения";
            if (adultDate?.getStartDay() > new Date(docDate))
                return "ВУ выдают с 18 лет";
        }

        return true;
    }
    public static beginDriverLicense=function(v:any)
    {
        if (v == "" || v == null) return true;
        if(v.match(/[0-3][0-9][.][0-1][0-9][.](19|20)([0-9]{2})/) != null || v != "Invalid Date")
        {
            const bd = new Date(v.replace(/(\d+)\.(\d+)\.(\d+)/, "$3-$2-$1"));
            const dn = new Date();

            if(bd.getTime()>dn.getTime())
            {
                return "Неверная дата"
            }
        }
        return true;
    };

    public static IsCarDateLicenseIssue = function (docDateIssue: Date, carDateIssue: Date): boolean | string {
        if (docDateIssue?.toString() == "Invalid Date" || carDateIssue?.toString() == "Invalid Date") return false;
        if (!carDateIssue) return true;
        if (docDateIssue) {
            if (docDateIssue < carDateIssue) return "Не может быть раньше даты выпуска авто";
        }
        return true;
    }

    public static maxYear=function(v:any)
    {
        if (v == "" || v == null) return true;
        if(v.toString().match(/^\d{4}$/) != null)
        {
            if(v>new Date().getFullYear()
            && v<new Date().addYears(-80).getFullYear())
            {
                return "Некорректный год. Пример: 2015"
            }
        }
        return true;
    };

    public static isName = (v: string) => !v || /^[а-яА-Я- ёЁ]*$/.test(v) || ValidationRules.leftLettersMessage;
    public static systemCountLimit = (v: string) => v.length < 40 || "Превышено разрешённое количество символов";

    public static isAlphanumeric = (v: string) => /^[a-zA-Z0-9]*$/.test(v) || ValidationRules.abstractText;
    public static isNumeric = (v: string) => /^\d*$/.test(v) || ValidationRules.abstractText;
    public static isCyrillic = (v: any) => /^[а-яА-ЯёЁ]*$/.test(v) || ValidationRules.leftLettersMessage;
    public static isCyrillicAndNumbers = (v: any) => /^[а-яА-ЯёЁ0-9]*$/.test(v) || ValidationRules.leftLettersMessage;
    public static isLatin = (v: any) => /^[a-zA-Z]*$/.test(v) || ValidationRules.leftLettersMessage;
    public static isLetters = (v: any) => /^[а-яА-Яa-zA-ZёЁ]*$/.test(v) || ValidationRules.leftLettersMessage;
    public static isLettersAndNumber = (v: any) => /^[а-яА-Яa-zA-Z0-9ёЁ]*$/.test(v) || ValidationRules.leftLettersMessage;
    public static isWithoutSigns = (v: any) => /^[^\W]*$/.test(v) || ValidationRules.isLettersAndNumber(v) || ValidationRules.leftLettersMessage;
    public static isWithoutNumbers = (v: any) => /^\D*$/.test(v) || ValidationRules.leftLettersMessage;
    public static isYear = (v: string) => /^\d{4}$/.test(v) || "Некорректный год. Пример: 2015"
    public static isCarPower = (v: string) => /^\d{1,5}$/.test(v) || /^\d{1,3}[.]\d{1,2}$/.test(v) || ValidationRules.abstractText;
    public static isCarPowerKeys = (v: string) => /^[0-9.]*$/.test(v) || ValidationRules.abstractText;
    public static isCarPowerEngine = function (v: string) {
        if (stringIsNullOrEmpty(v)) return "Обязательно к заполнению";
        const power = parseFloat(v);
        if (power >= 17 && power <= 999)
            return true;
        else
            return "Значение введено неверно";
    }
    public static isGosSign = (v: any)=> !v || /^[АВЕКМНОРСТУХFDTRVYJHCNE]{1}\d{3}[АВЕКМНОРСТУХFDTRVYJHCNE]{2}\d{2,3}$/i.test(v) || "В поле \"Гос. знак\" принимаются только заглавные буквы А, В, Е, К, М, Н, О, Р, С, Т, У, Х и цифры. А123АА12";

    public static dateMaxControl = function (max: any, min: any, strictly: boolean = true) {
        //mb to do
        if (typeof max !== typeof min) return "Несовпадение типов";

        let comparison = null;
        if (strictly) comparison = function (v1, v2) { return v1 > v2 };
        else comparison = function (v1, v2) { return v1 >= v2 };


        if (typeof max == "number" || typeof max == "string" || typeof max == "boolean") {
            if (comparison(max, min)) return true;
            else return ValidationRules.abstractText;
        }
        if (typeof max == "object" && typeof ValidationRules.dateRule(max) == "boolean" && typeof ValidationRules.dateRule(min) == "boolean") {
            if (comparison((max as Date).getTime(), (min as Date).getTime())) return true;
            else return ValidationRules.abstractText;
        }
        return "Сравнение невозможно"
    };

    //contacts
    public static isEmail = (v: string) => !v || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || "Неверный e-mail";
    public static isPhoneNumeric = (v: string) => !v || /(^['+']\d)|(^\d)/.test(v) || "Вводите телефон только цифрами";
    public static isPhone = (v: string) => !v || /(^.{3}\d{3}.\d{3}.\d{2}.\d{2}$)|(^\d{11}$)/.test(v) || "Неверный телефон";
    public static isPhoneRU = (v: string) => !v || /(^.["7"].["9"].*$)|(^\d{11}$)/.test(v) || "Телефон введен неправильно";
    public static isPhoneWithOutCode = (v: string) => /^\d{10}$/.test(v) || "Телефон введен неправильно";
    public static isHref = (v: string) => /^(http|https):\/\/\S{2,255}\S$/.test(v) || "Ссылка введена неверно";
    public static isPassword = (v: string) => !!v && v.length >= 6 || ValidationRules.errorPasswordMassage;

    //documents
    public static isSnils = (v: string) => /^\d{11}$/.test(v) || "Снилс введен неверно";
    public static isFisINN = (v: string) => /^\d{12}$/.test(v) || "ИНН введен неверно";
    public static isJurINN = (v: string) => /^\d{10,12}$/.test(v) || "ИНН введен неверно";
    public static isKpp = (v: string) => !v || /^\d{9}$/.test(v) || ValidationRules.abstractText;
    public static isOGRN = (v: string) => /^\d{13}|\d{15}$/.test(v) || "ОГРН введен неверно";
    public static isBankBik = (v: string) => /^\d{9}$/.test(v) || ValidationRules.abstractText;
    //40804; 40809; 40812; 40814; 40802 ; или первые три 407

    /*public static passport = {
        divisionCode: (v: string) => /^\d{6}$/.test(v) || ValidationRules.abstractText,
        series: (v: string) => /^\d{4}$/.test(v) || "Серия введена неверно",
        number: (v: string) => /^\d{6}$/.test(v) || "Номер введен неверно"
    };*/

    public static DriverLicense = (v: string) => !v || /(^\d{2}[а-яА-Я]{2}.\d{6}$)|(^\d{4}.\d{6}$)/.test(v) || ValidationRules.abstractText;
    public static Passport = (v: string) => !v || /^\d{4}.\d{6}$/.test(v) || ValidationRules.abstractText;
    public static vinRule = (v: string) => (/^[ABCDEFGHJKLMNPRSTUVWXYZ0-9]{17}$/.test(v)) || "Неверный VIN";


    public static bodyRule = (v: string) => (/^[A-Z0-9\-]{3,18}$/.test(v)) || "Неверный номер кузова";
    public static chassisRule = (v: string) => (/^[A-Z0-9\-]{3,20}$/.test(v)) || "Неверный номер шасси";
    public static chassisbodyNumberRule = (v: string) => (/^[A-Z0-9]+[\-]?[A-Z0-9]+$/.test(v)) || "Неверный номер";

    public static EPTSFull = (v: string) => v.length==15 || "Неверный номер";
    public static PTSSeries = (v: string) => !v || /(^\d{2}[а-яА-Я]{2}$)|(^\d{4}$)/.test(v) || "Неверная серия";
    public static STSSeries = (v: string) => !v || /(^\d{2}[а-яА-Я]{2}$)|(^\d{4}$)/.test(v) || "Неверная серия";
    public static STSPTSNumber = (v: string) => !v || /^\d{6}$/.test(v) || "Неверный номер";

    public static isDiagnosticCardNumber = (v: string) => /^\d{15}$/.test(v) || ValidationRules.abstractText;
    public static isDiagnosticCardNumberZero = (v: string) => v != "000000000000000" || ValidationRules.abstractText;
    public static diagnosticDate = function(v:any)
    {
        if (v == "" || v == null) return true;
        if(v.match(/[0-3][0-9][.][0-1][0-9][.](19|20)([0-9]{2})/) != null || v != "Invalid Date")
        {
            const bd = new Date(v.replace(/(\d+)\.(\d+)\.(\d+)/, "$3-$2-$1"));
            const dn = new Date();

            if(bd.getTime()<dn.getTime()
            || bd.getTime()>new Date(dn).addYears(3).getTime())
            {
                return "Неверная дата"
            }
        }
        return true;
    };

    public static SMSCode = (v: string) => !v || /^\d{4,}$/.test(v) || ValidationRules.abstractText;
    public static isSMSCodeKeys = (v: string) => /^[0-9]*$/i.test(v) || ValidationRules.abstractText;


    public static address = {
        reqState: function (v: GeoResp) {
            if (!v || !v.value || v.value == "") return "Укажите город/поселок регистрации";
            else if (!v.data.state || v.data.state == "") return "Адрес введен не полностью";
            else return true;
        },
        reqAddress: function (v: GeoResp) {
            if (!v || !v.value || v.value == "") return "Укажите город/поселок регистрации";
            else return true;
        },
        reqHouse: function (v: GeoResp & Address) {
            if (!v || !v.value || v.value == "") return "Начните ввод... (минимум 2 символа)";
            else if (v.data) {
                if (!v.data?.house || v.data?.house == "") return "Адрес введен не полностью";
            }
            else if (!v.house) return "Адрес введен не полностью";
            return true;
        },
        reqCity: function (v: GeoResp) {
            if (!v || !v.value || v.value == "") return "Укажите город/поселок регистрации";
            else if (!v.data.city || v.data.city == "" || v.data.city == "null. null") return "Адрес введен не полностью";
            else return true;
        },

        clearOrReqCity: function (v: GeoResp) {
            if (!v) return true;
            else if (!v.value || v.value == "") return "Обязательно к заполнению";
            else if (!v.data.city || v.data.city == "" || v.data.city == "null. null") return "Адрес введен не полностью";
            else return true;
        },
        clearOrReqHouse: function (v: GeoResp) {
            if (!v) return true;
            else if (!v.value || v.value == "") return "Обязательно к заполнению";
            else if (!v.data?.house || v.data?.house == "") return "Адрес введен не полностью";
            else return true;
        },
    };
}
